export const metaTags = {
    english: {
      title: 'BG Services Turkey',
      description: 'Bodyguard Services in Turkey',
      robots: 'index, follow',
      keywords: 'Bodyguard, Bodyguard Services, Bodyguard Services Turkey, Turkey BG, BG',
      og: {
        title: 'BG Services Turkey',
        description: 'Bodyguard Services in Turkey'
      },
      twitter: {
        title: 'BG Services Turkey',
        description: 'Bodyguard Services in Turkey', 
      }
    },
    turkish: {
      title: 'Bodyguard Servisleri Türkiye',
      description: 'Türkiye\'de Bodyguard Servisleri',
      robots: 'index, follow',
      keywords: 'Bodyguard, Bodyguard Servisleri, Türkiye BG',
      og: {
        title: 'Bodyguard Servisleri Türkiye',
        description: 'Türkiye\'de Bodyguard Servisleri'
      },
      twitter: {
        title: 'Bodyguard Servisleri Türkiye',
        description: 'Türkiye\'de Bodyguard Servisleri', 
      }
    },
    german: {
      title: 'Leibwächterdienste in der Türkei',
      description: 'Bodyguard-Dienste in der Türkei',
      robots: 'index, follow',
      keywords: 'Leibwächter, Leibwächterdienste, Dienstleistungen in der Türkei',
      og: {
        title: 'Leibwächterdienste in der Türkei',
        description: 'Bodyguard-Dienste in der Türkei'
      },
      twitter: {
        title: 'Leibwächterdienste in der Türkei',
        description: 'Bodyguard-Dienste in der Türkei',
      }
    },
    russian: {
      title: 'Услуги телохранителя в Турции',
      description: 'Услуги охраны в Турции',
      robots: 'index, follow',
      keywords: 'телохранитель, услуги телохранителя, Турция',
      og: {
        title: 'Услуги телохранителя в Турции',
        description: 'Услуги охраны в Турции'
      },
      twitter: {
        title: 'Услуги телохранителя в Турции',
        description: 'Услуги охраны в Турции',
      }
    },
    arabic: {
      title: 'خدمات الحراسة الشخصية في تركيا',
      description: 'خدمات الحراسة الشخصية في تركيا',
      robots: 'index, follow',
      keywords: 'حارس شخصي, خدمات الحراسة, تركيا',
      og: {
        title: 'خدمات الحراسة الشخصية في تركيا',
        description: 'خدمات الحراسة الشخصية في تركيا'
      },
      twitter: {
        title: 'خدمات الحراسة الشخصية في تركيا',
        description: 'خدمات الحراسة الشخصية في تركيا',
      }
    },
    ukraine: {
      title: 'Послуги охоронця в Туреччині',
      description: 'Охоронні послуги в Туреччині',
      robots: 'index, follow',
      keywords: 'охоронець, послуги охорони, Туреччина',
      og: {
        title: 'Послуги охоронця в Туреччині',
        description: 'Охоронні послуги в Туреччині'
      },
      twitter: {
        title: 'Послуги охоронця в Туреччині',
        description: 'Охоронні послуги в Туреччині',
      }
    },
    italian: {
      title: 'Servizi di guardia del corpo in Turchia',
      description: 'Servizi di protezione in Turchia',
      robots: 'index, follow',
      keywords: 'guardia del corpo, servizi di protezione, Turchia',
      og: {
        title: 'Servizi di guardia del corpo in Turchia',
        description: 'Servizi di protezione in Turchia'
      },
      twitter: {
        title: 'Servizi di guardia del corpo in Turchia',
        description: 'Servizi di protezione in Turchia',
      }
    },
    persian: {
      title: 'خدمات بادیگارد در ترکیه',
      description: 'خدمات امنیتی در ترکیه',
      robots: 'index, follow',
      keywords: 'بادیگارد, خدمات بادیگارد, ترکیه',
      og: {
        title: 'خدمات بادیگارد در ترکیه',
        description: 'خدمات امنیتی در ترکیه'
      },
      twitter: {
        title: 'خدمات بادیگارد در ترکیه',
        description: 'خدمات امنیتی در ترکیه',
      }
    },
    chinese: {
      title: '土耳其保镖服务',
      description: '土耳其的保镖服务',
      robots: 'index, follow',
      keywords: '保镖, 保镖服务, 土耳其',
      og: {
        title: '土耳其保镖服务',
        description: '土耳其的保镖服务'
      },
      twitter: {
        title: '土耳其保镖服务',
        description: '土耳其的保镖服务',
      }
    },
    french: {
      title: 'Services de garde du corps en Turquie',
      description: 'Services de protection en Turquie',
      robots: 'index, follow',
      keywords: 'garde du corps, services de garde, Turquie',
      og: {
        title: 'Services de garde du corps en Turquie',
        description: 'Services de protection en Turquie'
      },
      twitter: {
        title: 'Services de garde du corps en Turquie',
        description: 'Services de protection en Turquie',
      }
    },
    greece: {
      title: 'Υπηρεσίες Σωματοφυλάκων στην Τουρκία',
      description: 'Υπηρεσίες προστασίας στην Τουρκία',
      robots: 'index, follow',
      keywords: 'σωματοφύλακας, υπηρεσίες προστασίας, Τουρκία',
      og: {
        title: 'Υπηρεσίες Σωματοφυλάκων στην Τουρκία',
        description: 'Υπηρεσίες προστασίας στην Τουρκία'
      },
      twitter: {
        title: 'Υπηρεσίες Σωματοφυλάκων στην Τουρκία',
        description: 'Υπηρεσίες προστασίας στην Τουρκία',
      }
    },
    japon: {
      title: 'トルコのボディーガードサービス',
      description: 'トルコのセキュリティサービス',
      robots: 'index, follow',
      keywords: 'ボディーガード, セキュリティサービス, トルコ',
      og: {
        title: 'トルコのボディーガードサービス',
        description: 'トルコのセキュリティサービス'
      },
      twitter: {
        title: 'トルコのボディーガードサービス',
        description: 'トルコのセキュリティサービス',
      }
    },
    korean: {
      title: '터키의 경호원 서비스',
      description: '터키의 보안 서비스',
      robots: 'index, follow',
      keywords: '경호원, 보안 서비스, 터키',
      og: {
        title: '터키의 경호원 서비스',
        description: '터키의 보안 서비스'
      },
      twitter: {
        title: '터키의 경호원 서비스',
        description: '터키의 보안 서비스',
      }
    },
    pakistan: {
      title: 'ترکی میں باڈی گارڈ کی خدمات',
      description: 'ترکی میں سیکورٹی کی خدمات',
      robots: 'index, follow',
      keywords: 'باڈی گارڈ, سیکورٹی کی خدمات, ترکی',
      og: {
        title: 'ترکی میں باڈی گارڈ کی خدمات',
        description: 'ترکی میں سیکورٹی کی خدمات'
      },
      twitter: {
        title: 'ترکی میں باڈی گارڈ کی خدمات',
        description: 'ترکی میں سیکورٹی کی خدمات',
      }
    },
    romanian: {
      title: 'Servicii de gardă de corp în Turcia',
      description: 'Servicii de gardă de corp în Turcia',
      robots: 'index, follow',
      keywords: "Gardă de corp, Servicii de gardă, Servicii de gardă de corp în Turcia, Turcia BG, BG",
      og: {
        title: 'Servicii de gardă de corp în Turcia',
        description: 'Servicii de protecție în Turcia'
      },
      twitter: {
        title: 'Servicii de gardă de corp în Turcia',
        description: 'Servicii de protecție în Turcia',
      }
    },
};

export const keywords = {
  "english": [
    "Private security company in istanbul",
    "Private security company in turkey",
    "Bodyguard services istanbul",
    "Bodyguard istanbul",
    "Security istanbul",
    "Security company in istanbul",
    "Bodyguard in turkey",
    "Bodyguard services in turkey",
    "Security services in istanbul",
    "Security company in turkey",
    "Bodyguard company in turkey",
    "Private security in istanbul",
    "Private security in turkey",
    "Private security in antalya",
    "Bodyguard company in istanbul",
    "Bodyguard antalya"
  ],
  "turkish": [
    "İstanbul'da özel güvenlik şirketi",
    "Türkiye'de özel güvenlik şirketi",
    "İstanbul'da bodyguard hizmetleri",
    "İstanbul'da bodyguard",
    "İstanbul'da güvenlik",
    "İstanbul'da güvenlik şirketi",
    "Türkiye'de bodyguard",
    "Türkiye'de bodyguard hizmetleri",
    "İstanbul'da güvenlik hizmetleri",
    "Türkiye'de güvenlik şirketi",
    "Türkiye'de bodyguard şirketi",
    "İstanbul'da özel güvenlik",
    "Türkiye'de özel güvenlik",
    "Antalya'da özel güvenlik",
    "İstanbul'da bodyguard şirketi",
    "Antalya'da bodyguard"
  ],
  "german": [
    "Private Sicherheitsfirma in Istanbul",
    "Private Sicherheitsfirma in der Türkei",
    "Bodyguard-Dienste in Istanbul",
    "Bodyguard in Istanbul",
    "Sicherheit in Istanbul",
    "Sicherheitsfirma in Istanbul",
    "Bodyguard in der Türkei",
    "Bodyguard-Dienste in der Türkei",
    "Sicherheitsdienste in Istanbul",
    "Sicherheitsfirma in der Türkei",
    "Bodyguard-Firma in der Türkei",
    "Private Sicherheit in Istanbul",
    "Private Sicherheit in der Türkei",
    "Private Sicherheit in Antalya",
    "Bodyguard-Firma in Istanbul",
    "Bodyguard in Antalya"
  ],
  "russian": [
    "Частная охранная компания в Стамбуле",
    "Частная охранная компания в Турции",
    "Услуги телохранителей в Стамбуле",
    "Телохранитель в Стамбуле",
    "Безопасность в Стамбуле",
    "Охранная компания в Стамбуле",
    "Телохранитель в Турции",
    "Услуги телохранителей в Турции",
    "Охранные услуги в Стамбуле",
    "Охранная компания в Турции",
    "Компания телохранителей в Турции",
    "Частная охрана в Стамбуле",
    "Частная охрана в Турции",
    "Частная охрана в Анталии",
    "Компания телохранителей в Стамбуле",
    "Телохранитель в Анталии"
  ],
  "arabic": [
    "شركة أمن خاصة في إسطنبول",
    "شركة أمن خاصة في تركيا",
    "خدمات الحراسة الشخصية في إسطنبول",
    "حارس شخصي في إسطنبول",
    "الأمن في إسطنبول",
    "شركة أمن في إسطنبول",
    "حارس شخصي في تركيا",
    "خدمات الحراسة الشخصية في تركيا",
    "خدمات الأمن في إسطنبول",
    "شركة أمن في تركيا",
    "شركة حراس شخصيين في تركيا",
    "الأمن الخاص في إسطنبول",
    "الأمن الخاص في تركيا",
    "الأمن الخاص في أنطاليا",
    "شركة حراس شخصيين في إسطنبول",
    "حارس شخصي في أنطاليا"
  ],
  "ukraine": [
    "Приватна охоронна компанія в Стамбулі",
    "Приватна охоронна компанія в Туреччині",
    "Послуги охоронців у Стамбулі",
    "Охоронець у Стамбулі",
    "Безпека у Стамбулі",
    "Охоронна компанія в Стамбулі",
    "Охоронець у Туреччині",
    "Послуги охоронців у Туреччині",
    "Охоронні послуги в Стамбулі",
    "Охоронна компанія в Туреччині",
    "Компанія охоронців у Туреччині",
    "Приватна охорона у Стамбулі",
    "Приватна охорона в Туреччині",
    "Приватна охорона в Анталії",
    "Компанія охоронців у Стамбулі",
    "Охоронець в Анталії"
  ],
  "italian": [
    "Azienda di sicurezza privata a Istanbul",
    "Azienda di sicurezza privata in Turchia",
    "Servizi di bodyguard a Istanbul",
    "Bodyguard a Istanbul",
    "Sicurezza a Istanbul",
    "Azienda di sicurezza a Istanbul",
    "Bodyguard in Turchia",
    "Servizi di bodyguard in Turchia",
    "Servizi di sicurezza a Istanbul",
    "Azienda di sicurezza in Turchia",
    "Azienda di bodyguard in Turchia",
    "Sicurezza privata a Istanbul",
    "Sicurezza privata in Turchia",
    "Sicurezza privata ad Antalya",
    "Azienda di bodyguard a Istanbul",
    "Bodyguard ad Antalya"
  ],
  "persian": [
    "شرکت امنیتی خصوصی در استانبول",
    "شرکت امنیتی خصوصی در ترکیه",
    "خدمات بادیگارد در استانبول",
    "بادیگارد در استانبول",
    "امنیت در استانبول",
    "شرکت امنیتی در استانبول",
    "بادیگارد در ترکیه",
    "خدمات بادیگارد در ترکیه",
    "خدمات امنیتی در استانبول",
    "شرکت امنیتی در ترکیه",
    "شرکت بادیگارد در ترکیه",
    "امنیت خصوصی در استانبول",
    "امنیت خصوصی در ترکیه",
    "امنیت خصوصی در آنتالیا",
    "شرکت بادیگارد در استانبول",
    "بادیگارد در آنتالیا"
  ],
  "chinese": [
    "伊斯坦布尔的私人保安公司",
    "土耳其的私人保安公司",
    "伊斯坦布尔的保镖服务",
    "伊斯坦布尔保镖",
    "伊斯坦布尔安全",
    "伊斯坦布尔的保安公司",
    "土耳其保镖",
    "土耳其的保镖服务",
    "伊斯坦布尔的安全服务",
    "土耳其的保安公司",
    "土耳其的保镖公司",
    "伊斯坦布尔的私人保安",
    "土耳其的私人保安",
    "安塔利亚的私人保安",
    "伊斯坦布尔的保镖公司",
    "安塔利亚保镖"
  ],
  "french": [
    "Entreprise de sécurité privée à Istanbul",
    "Entreprise de sécurité privée en Turquie",
    "Services de garde du corps à Istanbul",
    "Garde du corps à Istanbul",
    "Sécurité à Istanbul",
    "Entreprise de sécurité à Istanbul",
    "Garde du corps en Turquie",
    "Services de garde du corps en Turquie",
    "Services de sécurité à Istanbul",
    "Entreprise de sécurité en Turquie",
    "Entreprise de garde du corps en Turquie",
    "Sécurité privée à Istanbul",
    "Sécurité privée en Turquie",
    "Sécurité privée à Antalya",
    "Entreprise de garde du corps à Istanbul",
    "Garde du corps à Antalya"
  ],
  "greece": [
    "Ιδιωτική εταιρεία ασφαλείας στην Κωνσταντινούπολη",
    "Ιδιωτική εταιρεία ασφαλείας στην Τουρκία",
    "Υπηρεσίες σωματοφυλάκων στην Κωνσταντινούπολη",
    "Σωματοφύλακας στην Κωνσταντινούπολη",
    "Ασφάλεια στην Κωνσταντινούπολη",
    "Εταιρεία ασφαλείας στην Κωνσταντινούπολη",
    "Σωματοφύλακας στην Τουρκία",
    "Υπηρεσίες σωματοφυλάκων στην Τουρκία",
    "Υπηρεσίες ασφαλείας στην Κωνσταντινούπολη",
    "Εταιρεία ασφαλείας στην Τουρκία",
    "Εταιρεία σωματοφυλάκων στην Τουρκία",
    "Ιδιωτική ασφάλεια στην Κωνσταντινούπολη",
    "Ιδιωτική ασφάλεια στην Τουρκία",
    "Ιδιωτική ασφάλεια στην Αττάλεια",
    "Εταιρεία σωματοφυλάκων στην Κωνσταντινούπολη",
    "Σωματοφύλακας στην Αττάλεια"
  ],
  "japon": [
    "イスタンブールのプライベートセキュリティ会社",
    "トルコのプライベートセキュリティ会社",
    "イスタンブールのボディーガードサービス",
    "イスタンブールのボディーガード",
    "イスタンブールのセキュリティ",
    "イスタンブールのセキュリティ会社",
    "トルコのボディーガード",
    "トルコのボディーガードサービス",
    "イスタンブールのセキュリティサービス",
    "トルコのセキュリティ会社",
    "トルコのボディーガード会社",
    "イスタンブールのプライベートセキュリティ",
    "トルコのプライベートセキュリティ",
    "アンタルヤのプライベートセキュリティ",
    "イスタンブールのボディーガード会社",
    "アンタルヤのボディーガード"
  ],
  "korean": [
    "이스탄불의 개인 보안 회사",
    "터키의 개인 보안 회사",
    "이스탄불의 바디가드 서비스",
    "이스탄불 바디가드",
    "이스탄불 보안",
    "이스탄불 보안 회사",
    "터키의 바디가드",
    "터키의 바디가드 서비스",
    "이스탄불의 보안 서비스",
    "터키의 보안 회사",
    "터키의 바디가드 회사",
    "이스탄불의 개인 보안",
    "터키의 개인 보안",
    "안탈리아의 개인 보안",
    "이스탄불의 바디가드 회사",
    "안탈리아 바디가드"
  ],
  "pakistan": [
    "اسطنبول میں نجی سیکیورٹی کمپنی",
    "ترکی میں نجی سیکیورٹی کمپنی",
    "اسطنبول میں باڈی گارڈ خدمات",
    "اسطنبول میں باڈی گارڈ",
    "اسطنبول میں سیکیورٹی",
    "اسطنبول میں سیکیورٹی کمپنی",
    "ترکی میں باڈی گارڈ",
    "ترکی میں باڈی گارڈ خدمات",
    "اسطنبول میں سیکیورٹی خدمات",
    "ترکی میں سیکیورٹی کمپنی",
    "ترکی میں باڈی گارڈ کمپنی",
    "اسطنبول میں نجی سیکیورٹی",
    "ترکی میں نجی سیکیورٹی",
    "انطالیہ میں نجی سیکیورٹی",
    "اسطنبول میں باڈی گارڈ کمپنی",
    "انطالیہ میں باڈی گارڈ"
  ],
  "romanian": [
    "Companie de securitate privată în Istanbul",
    "Companie de securitate privată în Turcia",
    "Servicii de bodyguard în Istanbul",
    "Bodyguard în Istanbul",
    "Securitate în Istanbul",
    "Companie de securitate în Istanbul",
    "Bodyguard în Turcia",
    "Servicii de bodyguard în Turcia",
    "Servicii de securitate în Istanbul",
    "Companie de securitate în Turcia",
    "Companie de bodyguard în Turcia",
    "Securitate privată în Istanbul",
    "Securitate privată în Turcia",
    "Securitate privată în Antalya",
    "Companie de bodyguard în Istanbul",
    "Bodyguard în Antalya"
  ]
}

export const languages = [
  "english",
  "turkish",
  "german",
  "russian",
  "arabic",
  "ukraine",
  "italian",
  "persian",
  "chinese",
  "french",
  "greece",
  "japon",
  "korean",
  "pakistan",
  "romanian" 
];